module.exports = __webpack_public_path__ + "media/images/payment-providers/lightning-03fc35683f11260627ef85869fec5503.svg";